<template>
    <div :class="{form_rtl: currentSubmittingLanguage != 'english', form_ltr: currentSubmittingLanguage == 'english'}">
        <div v-if="checkConditions">
            <va-page-header class="fixed_direction" v-if="$route.matched[0].name == 'surveys'">

                <div slot="title">
                    <va-button v-if="!$route.meta.isPublicView" class="back_button" @click.native="$router.go(-1)"
                        type="default" size="lg">
                        <va-icon type="chevron-left"></va-icon>
                    </va-button>

                    <span v-if="viewedForm && $route.matched[0].name == 'surveys'">{{ g_getSurveyFieldStuffWithThisPrefix({'englishLabel': viewedForm.get('label_english'),
                        'pashtoLabel': viewedForm.get('label_pashto'),'dariLabel': viewedForm.get('label_dari'),},
                        currentSubmittingLanguage, 'Label', formLanguages) }}</span>
                </div>

                <div slot="actions" v-if="!is_preview">
                    <va-button
                        v-if="!viewedSubmission && ($route.meta.isPublicView || ($route.matched[0].name == 'surveys' && ((user.get('roles').includes('admin') || user.get('roles').includes('manager') || ((user.get('roles').includes('submitter') || user.get('roles').includes('survey-editor')) && userIsSubmitter)))))"
                        @click.native="submitNewEntry" type="primary" size="lg" :class="{no_click: loading}">{{
                                                _('SUBMIT') }}</va-button>
                    <va-button
                        v-if="viewedSubmission && $route.matched[0].name == 'surveys' && (user.get('roles').includes('admin') || user.get('roles').includes('manager') || (viewedSubmission.get('createdBy') && viewedSubmission.get('createdBy').id == user.id))"
                        @click.native="updateSubmission" type="primary" size="lg" :class="{no_click: loading}">{{
                                                                        _('UPDATE') }}</va-button>
                </div>

            </va-page-header>

            <va-form type="vertical" ref="form" class="form_submitter">
                <!-- languages -->
                <div class="fixed_direction" v-if="!viewedSubmission && formLanguages && formLanguages.length > 1">
                    <va-radio-group v-model="currentSubmittingLanguage">
                        <va-radio-btn v-for="(lang, index) in formLanguages" :checked="index == 0" :label="lang">
                            {{ _translateWithLocalLanguage(lang, lang) }}</va-radio-btn>
                    </va-radio-group>
                </div>

                <!-- each form item -->
                <va-form-item class="field_item" style="display: block">
                    <div v-for="(field, index) in viewedFormFields" :key="index" style="padding-left: 10px;
                                                padding-right: 4px;"
                        :class="{error_indicator: checkErrorCondition(field) && field.type != 'heading' && field.type != 'description', click: !field.editable && viewedSubmission}">

                        <!-- heading  -->
                        <h1 v-if="field.type=='heading'">
                            {{ g_getSurveyFieldStuffWithThisPrefix(field, currentSubmittingLanguage, 'Label', formLanguages) }}
                        </h1>

                        <!-- description  -->
                        <p>
                            <span
                                v-if="field.type=='description'">{{ g_getSurveyFieldStuffWithThisPrefix(field, currentSubmittingLanguage, 'Label', formLanguages) }}</span>
                        </p>

                        <!-- small text field -->
                        <div v-if="field.type=='text'">
                            <span
                                class="field_label">{{ g_getSurveyFieldStuffWithThisPrefix(field, currentSubmittingLanguage, 'Label', formLanguages) }}</span>
                            <va-input style="width: 100%" class="full_with_input" :type="field.fieldType"
                                name="smallText" v-model="theVarsEnglish[field.fieldDatabaseName]"
                                :placeholder="g_getSurveyFieldStuffWithThisPrefix(field, currentSubmittingLanguage, 'Placeholder', formLanguages)">
                            </va-input>
                            <span class="field_label" style="color: red" v-if="!field.editable && viewedSubmission">
                                {{ _('Not editable')}}</span>

                            <span style="color:#848890; padding: 0 0 0 2px; font-size: 12px">
                                {{ g_getSurveyFieldStuffWithThisPrefix(field, currentSubmittingLanguage, 'Note', formLanguages) }}</span><br
                                v-if="g_getSurveyFieldStuffWithThisPrefix(field, currentSubmittingLanguage, 'Note', formLanguages)">
                            <span style="color: red;" v-if="checkErrorCondition(field)">
                                {{ errorContent['message' + currentSubmittingLanguage.charAt(0).toUpperCase() + currentSubmittingLanguage.slice(1)] }}</span>
                        </div>

                        <!-- large text field -->
                        <div v-if="field.type=='textarea'">
                            <span
                                class="field_label">{{ g_getSurveyFieldStuffWithThisPrefix(field, currentSubmittingLanguage, 'Label', formLanguages) }}</span>
                            <va-textarea name="largeText" v-model="theVarsEnglish[field.fieldDatabaseName]"
                                :placeholder="g_getSurveyFieldStuffWithThisPrefix(field, currentSubmittingLanguage, 'Placeholder', formLanguages)">
                            </va-textarea>
                            <span class="field_label" style="color: red" v-if="!field.editable && viewedSubmission">
                                {{ _('Not editable')}}</span>

                            <span style="color:#848890; padding: 0 0 0 2px; font-size: 12px">
                                {{ g_getSurveyFieldStuffWithThisPrefix(field, currentSubmittingLanguage, 'Note', formLanguages) }}</span><br
                                v-if="g_getSurveyFieldStuffWithThisPrefix(field, currentSubmittingLanguage, 'Note', formLanguages)">
                            <span style="color: red;" v-if="checkErrorCondition(field)">
                                {{ errorContent['message' + currentSubmittingLanguage.charAt(0).toUpperCase() + currentSubmittingLanguage.slice(1)] }}</span>
                        </div>

                        <!-- date -->
                        <!-- hello -->
                        <div v-if="field.type=='date'">
                            <span
                                class="field_label">{{ g_getSurveyFieldStuffWithThisPrefix(field, currentSubmittingLanguage, 'Label', formLanguages) }}</span>
                            <div v-if="field.isTime">
                                <va-timepicker v-model="theVarsEnglish[field.fieldDatabaseName]"
                                    :hourRange="[hourRangeMin, hourRangeMax]"
                                    :minuteRange="[minuteRangeMin, minuteRangeMax]"
                                    :secondRange="[secondRangeMin, secondRangeMax]" />
                            </div>

                            <div v-else>
                                <date-picker v-if="field.isHijri" v-model="theVarsEnglish[field.fieldDatabaseName]">
                                </date-picker>

                                <va-datepicker v-else name="date" v-model="theVarsEnglish[field.fieldDatabaseName]"
                                    format="yyyy/MM/dd">
                                </va-datepicker>
                            </div>

                            <span class="field_label" style="color: red" v-if="!field.editable && viewedSubmission">
                                {{ _('Not editable')}}</span>

                            <span style="color:#848890; padding: 0 0 0 2px; font-size: 12px">
                                {{ g_getSurveyFieldStuffWithThisPrefix(field, currentSubmittingLanguage, 'Note', formLanguages) }}</span><br
                                v-if="g_getSurveyFieldStuffWithThisPrefix(field, currentSubmittingLanguage, 'Note', formLanguages)">
                            <span style="color: red;" v-if="checkErrorCondition(field)">
                                {{ errorContent['message' + currentSubmittingLanguage.charAt(0).toUpperCase() + currentSubmittingLanguage.slice(1)] }}</span>
                        </div>

                        <!-- yes-no (checkbox) -->
                        <div :class="{rtl_checkbox: currentSubmittingLanguage != 'english'}"
                            v-if="field.type=='checkbox'">
                            <span class="field_label">{{ _('Yes/No') }}</span>
                            <va-checkbox name="checkbox" v-model="theVarsEnglish[field.fieldDatabaseName]">
                                {{ g_getSurveyFieldStuffWithThisPrefix(field, currentSubmittingLanguage, 'Label', formLanguages) }}
                            </va-checkbox>
                            <span class="field_label" style="color: red" v-if="!field.editable && viewedSubmission">
                                {{ _('Not editable')}}</span>
                            <br>
                            <span style="color:#848890; padding: 0 0 0 2px; font-size: 12px">
                                {{ g_getSurveyFieldStuffWithThisPrefix(field, currentSubmittingLanguage, 'Note', formLanguages) }}</span><br
                                v-if="g_getSurveyFieldStuffWithThisPrefix(field, currentSubmittingLanguage, 'Note', formLanguages)">
                            <span style="color: red;" v-if="checkErrorCondition(field)">
                                {{ errorContent['message' + currentSubmittingLanguage.charAt(0).toUpperCase() + currentSubmittingLanguage.slice(1)] }}</span>
                        </div>

                        <!-- multiple option -->
                        <div v-if="field.type == 'multiple-option'">
                            <span
                                class="field_label">{{ g_getSurveyFieldStuffWithThisPrefix(field, currentSubmittingLanguage, 'Label', formLanguages) }}</span>
                            <va-checkbox-group :class="{rtl_checkbox: currentSubmittingLanguage != 'english'}"
                                name="multipleOptions" vertical v-model="theVarsEnglish[field.fieldDatabaseName]">
                                <va-checkbox v-for="(option, key) in field.options" :label="option.value">
                                    {{ g_getSurveyFieldStuffWithThisPrefix(option, currentSubmittingLanguage, 'Label', formLanguages) }}
                                </va-checkbox>
                            </va-checkbox-group>
                            <span class="field_label" style="color: red" v-if="!field.editable && viewedSubmission">
                                {{ _('Not editable')}}</span>
                            <br>
                            <span style="color:#848890; padding: 0 0 0 2px; font-size: 12px">
                                {{ g_getSurveyFieldStuffWithThisPrefix(field, currentSubmittingLanguage, 'Note', formLanguages) }}</span><br
                                v-if="g_getSurveyFieldStuffWithThisPrefix(field, currentSubmittingLanguage, 'Note', formLanguages)">
                            <span style="color: red;" v-if="checkErrorCondition(field)">
                                {{ errorContent['message' + currentSubmittingLanguage.charAt(0).toUpperCase() + currentSubmittingLanguage.slice(1)] }}</span>
                        </div>

                        <!-- single option -->
                        <div v-if="field.type=='single-option'">
                            <span
                                class="field_label">{{ g_getSurveyFieldStuffWithThisPrefix(field, currentSubmittingLanguage, 'Label', formLanguages) }}</span>
                            <va-radio-group :class="{rtl_radio: currentSubmittingLanguage != 'english'}"
                                :key="Date.now()" name="singleOptions" vertical
                                v-model="theVarsEnglish[field.fieldDatabaseName]">
                                <va-radio v-for="option in field.options" :label="option.value"><span
                                        style="word-wrap: break-word">
                                        {{ g_getSurveyFieldStuffWithThisPrefix(option, currentSubmittingLanguage, 'Label', formLanguages) }}</span>
                                </va-radio>
                            </va-radio-group>
                            <span class="field_label" style="color: red" v-if="!field.editable && viewedSubmission">
                                {{ _('Not editable')}}</span>
                            <br>
                            <span style="color:#848890; padding: 0 0 0 2px; font-size: 12px">
                                {{ g_getSurveyFieldStuffWithThisPrefix(field, currentSubmittingLanguage, 'Note', formLanguages) }}</span><br
                                v-if="g_getSurveyFieldStuffWithThisPrefix(field, currentSubmittingLanguage, 'Note', formLanguages)">
                            <span style="color: red;" v-if="checkErrorCondition(field)">
                                {{ errorContent['message' + currentSubmittingLanguage.charAt(0).toUpperCase() + currentSubmittingLanguage.slice(1)] }}</span>
                        </div>

                        <!-- select -->
                        <div v-if="field.type=='select'">
                            <span
                                class="field_label">{{ g_getSurveyFieldStuffWithThisPrefix(field, currentSubmittingLanguage, 'Label', formLanguages) }}</span>

                            <va-select :search="true" :show-selected="true" name="listSelection"
                                v-model="theVarsEnglish[field.fieldDatabaseName]" type="default" class="select-border"
                                :placeholder="_translateWithLocalLanguage('Select an option', currentSubmittingLanguage)"
                                size="md" :multiple="field.multiple" :options="getSelectOptions(field.options)">
                            </va-select>
                            <span class="field_label" style="color: red" v-if="!field.editable && viewedSubmission">
                                {{ _('Not editable')}}</span>
                            <br>
                            <span style="color:#848890; padding: 0 0 0 2px; font-size: 12px">
                                {{ g_getSurveyFieldStuffWithThisPrefix(field, currentSubmittingLanguage, 'Note', formLanguages) }}</span><br
                                v-if="g_getSurveyFieldStuffWithThisPrefix(field, currentSubmittingLanguage, 'Note', formLanguages)">
                            <span style="color: red;" v-if="checkErrorCondition(field)">
                                {{ errorContent['message' + currentSubmittingLanguage.charAt(0).toUpperCase() + currentSubmittingLanguage.slice(1)] }}</span>
                        </div>

                        <!-- map -->
                        <div v-if="field.type=='single-geolocation' || field.type=='multiple-geolocation'">
                            <span
                                class="field_label">{{ g_getSurveyFieldStuffWithThisPrefix(field, currentSubmittingLanguage, 'Label', formLanguages) }}</span>

                            <GmapMap @click="mapClicked($event, field)" :center="{lat:34.55, lng:69.20}" :zoom="5"
                                map-type-id="terrain" style="height: 200px; padding: 0; margin: 0">
                                <GmapMarker v-if="field.type=='multiple-geolocation'" :key="index"
                                    v-for="(m, index) in theVarsEnglish[field.fieldDatabaseName]" :position="m.position"
                                    :clickable="true" @click="center=m.position"
                                    @dblclick="removeMarker(field, index)" />
                                <GmapMarker v-if="field.type=='single-geolocation'" @dblclick="removeSingleGeolocation"
                                    :position="{lat:theVarsEnglish['latitude'], lng: theVarsEnglish['longitude']}"
                                    :clickable="true" @click="center=m.position" />
                            </GmapMap>
                            <span class="field_label" style="color: red" v-if="!field.editable && viewedSubmission">
                                {{ _('Not editable')}}</span>
                            <br>
                            <va-button
                                :class="{lat_rtl: currentSubmittingLanguage != 'english', lat_ltr: currentSubmittingLanguage == 'english'}"
                                @click.native="getCurrentLocation(field)" type="info">
                                {{ _translateWithLocalLanguage('Get Current Location', currentSubmittingLanguage) }}
                            </va-button>
                            <br>

                            <div
                                :class="{submissionSection: $route.matched[0].name == 'surveys', otherSection: $route.matched[0].name != 'surveys'}">
                                <va-input
                                    :class="{lat_rtl: currentSubmittingLanguage != 'english', lat_ltr: currentSubmittingLanguage == 'english'}"
                                    :ref="'lat_' + index" type="number" :name="'lat_' + index"
                                    v-model="theVarsEnglish['lat_' + index]"
                                    :placeholder="_translateWithLocalLanguage('Latitude', currentSubmittingLanguage)">
                                </va-input>
                                <va-input
                                    :class="{long_rtl: currentSubmittingLanguage != 'english', long_ltr: currentSubmittingLanguage == 'english'}"
                                    :ref="'lng_' + index" :name="'lng_' + index" type="number"
                                    :placeholder="_translateWithLocalLanguage('Longitude', currentSubmittingLanguage)"
                                    v-model="theVarsEnglish['lng_' + index]">
                                </va-input>
                                <va-button type="primary" @click.native="insertLocation(field, index)">
                                    {{ _translateWithLocalLanguage('Insert', currentSubmittingLanguage) }}
                                </va-button>
                            </div>

                            <span style="color:#848890; padding: 0 0 0 2px; font-size: 12px">
                                {{ g_getSurveyFieldStuffWithThisPrefix(field, currentSubmittingLanguage, 'Note', formLanguages) }}</span><br
                                v-if="g_getSurveyFieldStuffWithThisPrefix(field, currentSubmittingLanguage, 'Note', formLanguages)">

                            <span style="color: red;" v-if="checkErrorCondition(field)">
                                {{ errorContent['message' + currentSubmittingLanguage.charAt(0).toUpperCase() + currentSubmittingLanguage.slice(1)] }}</span>
                        </div>

                        <!-- attachment -->
                        <div v-if="field.type=='attachment'">
                            <span
                                class="field_label">{{ g_getSurveyFieldStuffWithThisPrefix(field, currentSubmittingLanguage, 'Label', formLanguages) }}</span>

                            <input @change="loadAttachments($event, field)" type="file" id="attachment"
                                name="attachment" :multiple="field.multiple"></input>

                            <!-- multiple attachment -->
                            <div v-if="theVarsEnglish[field.fieldDatabaseName]">
                                <div v-if="field.multiple"
                                    style="display: flex; flex-direction: row; align-items: flex-end; flex-wrap:wrap; flex:auto;">
                                    <div v-for="(file, index) in theVarsEnglish[field.fieldDatabaseName]"
                                        style="display: flex; flex-direction: row; margin-right: 8px;">
                                        <div style="display:flex; flex-direction: column">
                                            <div class="file_chip">
                                                <span class="file_text">{{ file.file.name }}</span>
                                                <va-button style="margin-top: -3px;" type="subtle-link"
                                                    @click.native="removeAttachment(field, index)">
                                                    <va-icon type="times"></va-icon>
                                                </va-button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- single attachment -->
                                <div v-else-if="!field.multiple"
                                    style="display: flex; flex-direction: row; align-items: flex-end; flex-wrap:wrap; flex:auto;">
                                    <div style="display: flex; flex-direction: row; margin-right: 8px;">
                                        <div style="display:flex; flex-direction: column">
                                            <div class="file_chip">
                                                <span
                                                    class="file_text">{{ theVarsEnglish[field.fieldDatabaseName].file.name }}</span>
                                                <va-button style="margin-top: -3px;" type="subtle-link"
                                                    @click.native="removeAttachment(field, index)">
                                                    <va-icon type="times"></va-icon>
                                                </va-button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <span class="field_label" style="color: red" v-if="!field.editable && viewedSubmission">
                                {{ _('Not editable')}}</span>

                            <span style="color:#848890; padding: 0 0 0 2px; font-size: 12px">
                                {{ g_getSurveyFieldStuffWithThisPrefix(field, currentSubmittingLanguage, 'Note', formLanguages) }}</span><br
                                v-if="g_getSurveyFieldStuffWithThisPrefix(field, currentSubmittingLanguage, 'Note', formLanguages)">
                            <span style="color: red;" v-if="checkErrorCondition(field)">
                                {{ errorContent['message' + currentSubmittingLanguage.charAt(0).toUpperCase() + currentSubmittingLanguage.slice(1)] }}</span>
                        </div>
                    </div>
                </va-form-item>
            </va-form>
        </div>
        <div v-else class="not_available">
            <span style="vertical-align: middle;">
                {{ _('Not available') }}
            </span>
        </div>
    </div>
</template>

<script>
    // @ is an alias to /src
    import Parse from "@/main.js"
    import { mapGetters, mapActions } from "vuex";
    import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
    import moment from 'jalali-moment';

    export default {

        props: ['is_preview', 'passedForm', 'selectedFormId', 'metaData', 'hasData', 'viewedMetaFormSelectedLanguage'],

        components: {
            datePicker: VuePersianDatetimePicker
        },

        data() {
            return {
                viewedForm: { get: () => '' },
                date: '',
                myForm: null,
                viewedSubmission: null,
                viewedFormFields: [],
                theVarsEnglish: {},
                formLanguages: [],

                errorContent: {},
                errorEnglish: {},
                errorPashto: {},
                errorDari: {},

                isThisUserSubmitter: false,
                lat: 0,
                long: 0,
                currentSubmittingLanguage: '',
                selectedLanguages: [],
                viewedMetaFormRecordEnglish: null,
                viewedMetaFormRecordPashto: null,
                viewedMetaFormRecordDari: null,

                value: '',
                format: 'hh:mm:ss',
                readonly: true,
                hourRangeMin: 0,
                hourRangeMax: 23,
                minuteRangeMin: 0,
                minuteRangeMax: 59,
                secondRangeMin: 0,
                secondRangeMax: 59,

            };
        },

        computed: {
            ...mapGetters(['user', 'getSystemLanguage', 'getCurrentCategory', 'getCurrentDepartment', 'loading']),



            checkConditions() {
                if ((this.$route.meta.isPublicView && this.viewedForm && this.viewedForm.get('is_form_public_available')) || this.user) {
                    return true;
                }
                return false;
            },

            check1() {
                return this.$route.matched[0].name != 'surveys' ? (this.formLanguages.includes('english') && this.selectedLanguages.includes('english')) : this.formLanguages.includes('english')
            },
            check2() {
                return this.$route.matched[0].name != 'surveys' ? (this.formLanguages.includes('pashto') && this.selectedLanguages.includes('pashto')) : this.formLanguages.includes('pashto')
            },
            check3() {
                return this.$route.matched[0].name != 'surveys' ? (this.formLanguages.includes('dari') && this.selectedLanguages.includes('dari')) : this.formLanguages.includes('dari')
            },

            userIsSubmitter() {
                var isSubmitter = false;
                if (this.myForm != null && this.myForm.get('survey_submitters') != null) {
                    for (let i = 0; i < this.myForm.get('survey_submitters').length; i++) {
                        const submitter = this.myForm.get('survey_submitters')[i];
                        if (submitter != null && this.user != null && submitter.id == this.user.id) {
                            isSubmitter = true;
                            break
                        }
                    }
                }
                return isSubmitter;
            }
        },

        watch: {

            async '$route'(to, from) {
                await this.fetchings()
            },

            getSystemLanguage(lang) {
                if (this.viewedForm) {
                    if (this.viewedForm.get('form_languages') && this.viewedForm.get('form_languages').includes(lang)) {
                        this.currentSubmittingLanguage = lang
                    }
                }
            },


            selectedLanguages: function (val) {
                if (this.selectedLanguages.length == 0) {
                    this.selectedLanguages.push('english')
                }
            },

            viewedMetaFormSelectedLanguage(val) {
                this.selectedLanguages = val
            },

            metaData(val) {
                if (val) {
                    this.currentSubmittingLanguage = val.get('submission_language')
                    this.viewedSubmission = val
                    this.fetchedSubmissionDataBinding()
                }
            },

            selectedFormId: async function (val) {
                let q = new Parse.Query('Form')
                let selectedForm = await q.get(this.selectedFormId)
                this.viewedForm = selectedForm
                this.myForm = selectedForm
                if (this.viewedForm) {
                    this.viewedFormFields = selectedForm.get('layout')
                    this.formLanguages = selectedForm.get('form_languages')
                    if (!this.hasData) {
                        this.varBinder()
                    } else {

                        this.fetchedSubmissionDataBinding()
                    }
                }
            }
        },

        methods: {
            ...mapActions([]),

            checkErrorCondition(field) {
                if (this.currentSubmittingLanguage == 'english') {
                    return this.errorContent.messageEnglish != '' && this.errorContent.fieldDatabaseName == field.fieldDatabaseName;
                } else if (this.currentSubmittingLanguage == 'pashto') {
                    return this.errorContent.messagePashto != '' && this.errorContent.fieldDatabaseName == field.fieldDatabaseName;
                } else if (this.currentSubmittingLanguage == 'dari') {
                    return this.errorContent.messageDari != '' && this.errorContent.fieldDatabaseName == field.fieldDatabaseName;
                }
            },

            getSelectOptions(options) {
                var newOptions = options.map(option => {
                    var label = '';
                    if (this.currentSubmittingLanguage == 'english') {
                        label = option.englishLabel
                    } else if (this.currentSubmittingLanguage == 'pashto') {
                        label = option.pashtoLabel
                    } else if (this.currentSubmittingLanguage == 'dari') {
                        label = option.dariLabel
                    }
                    return {
                        label: label,
                        ...option
                    }
                })
                return newOptions
            },

            removeMarker(field, index) {
                this.theVarsEnglish[field.fieldDatabaseName].splice(index, 1)

            },

            removeSingleGeolocation() {
                this.theVarsEnglish['latitude'] = 0
                this.theVarsEnglish['longitude'] = 0
            },

            insertLocation(field, index) {

                let lat = parseFloat(this.theVarsEnglish['lat_' + index]);
                let lng = parseFloat(this.theVarsEnglish['lng_' + index]);

                if (field.type == 'single-geolocation') {
                    this.theVarsEnglish['latitude'] = lat
                    this.theVarsEnglish['longitude'] = lng
                } else {
                    this.theVarsEnglish[field.fieldDatabaseName].push({ position: { lat: lat, lng: lng } });
                }
                this.theVarsEnglish = { ...this.theVarsEnglish };
            },

            mapClicked(loc, item) {
                if (item.type == 'single-geolocation') {
                    this.theVarsEnglish['latitude'] = loc.latLng.lat()
                    this.theVarsEnglish['longitude'] = loc.latLng.lng()
                } else {

                    this.theVarsEnglish[item.fieldDatabaseName].push({ position: { lat: loc.latLng.lat(), lng: loc.latLng.lng() } });
                }
                this.theVarsEnglish = { ...this.theVarsEnglish };
            },

            getCurrentLocation(item) {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition((loc) => {
                        if (item.type == 'single-geolocation') {
                            this.theVarsEnglish['latitude'] = loc.coords.latitude
                            this.theVarsEnglish['longitude'] = loc.coords.longitude
                        } else {
                            this.theVarsEnglish[item.fieldDatabaseName].push({ position: { lat: loc.coords.latitude, lng: loc.coords.longitude } })
                        }
                    });
                } else {
                    x.innerHTML = "Geolocation is not supported by this browser.";
                }
            },


            loadAttachments(ev, field) {
                if (field.multiple)
                    for (let index = 0; index < ev.target.files.length; index++) {
                        this.theVarsEnglish[field.fieldDatabaseName].push({ file: ev.target.files[index], isNew: true })
                    }
                else {
                    this.theVarsEnglish[field.fieldDatabaseName] = { file: ev.target.files[0], isNew: true }
                }
                this.theVarsEnglish = { ...this.theVarsEnglish }
            },

            removeAttachment(field, index) {
                if (this.theVarsEnglish[field.fieldDatabaseName]) {
                    if (field.multiple) {
                        this.theVarsEnglish[field.fieldDatabaseName].splice(index, 1)
                    } else if (!field.multiple) {
                        this.theVarsEnglish[field.fieldDatabaseName] = ''
                    }
                }
                this.theVarsEnglish = { ...this.theVarsEnglish }
            },


            uploadAttachments(field) {
                var promises = []
                if (field.multiple) {
                    if (this.theVarsEnglish[field.fieldDatabaseName]) {
                        for (let index = 0; index < this.theVarsEnglish[field.fieldDatabaseName].length; index++) {
                            if (this.theVarsEnglish[field.fieldDatabaseName][index].isNew) {
                                promises.push(new Promise(async (resolve, reject) => {
                                    var name = Date.now().toString() + this.theVarsEnglish[field.fieldDatabaseName][index].file.name.slugify(true);
                                    var parseFile = new Parse.File(name, this.theVarsEnglish[field.fieldDatabaseName][index].file);
                                    await parseFile.save()
                                        .then(function (file) {
                                            resolve({ url: file._url, field })
                                        }, function (error) {
                                        });
                                }))
                            }
                        }
                    }
                }
                else {
                    if (this.theVarsEnglish[field.fieldDatabaseName] && this.theVarsEnglish[field.fieldDatabaseName].isNew) {
                        promises.push(new Promise(async (resolve, reject) => {
                            var name = Date.now().toString() + this.theVarsEnglish[field.fieldDatabaseName].file.name.slugify(true);
                            var parseFile = new Parse.File(name, this.theVarsEnglish[field.fieldDatabaseName].file);
                            await parseFile.save()
                                .then(function (file) {
                                    resolve({ url: file._url, field })
                                }, function (error) {
                                });
                        }))
                    }
                }
                return promises
            },

            async submitData() {
                if (this.is_preview) return false;
                return new Promise(async (resolve, reject) => {
                    this.$store.commit('setLoading', true)
                    var attatchmentsIds = []

                    // this loop is only for uploading attachments
                    if (this.$route.matched[0].name == 'surveys') {
                        for (let index = 0; index < this.viewedFormFields.length; index++) {
                            if (this.viewedFormFields[index].type == 'attachment') {
                                // uploading attachments
                                await Promise.all(this.uploadAttachments(this.viewedFormFields[index]))
                                    .then(attachmentsUrls => {
                                        attatchmentsIds.push(...attachmentsUrls)
                                    })
                            }
                        }
                    }

                    var theUser;

                    if (this.$route.meta.isPublicView) {
                        let q = new Parse.Query('User')
                        q.equalTo('email', 'nepapublicuser@gmail.com')
                        theUser = await q.first()
                    } else {
                        theUser = this.user
                    }
                    let instanceEnglish = {}
                    instanceEnglish.status = 'pending'
                    instanceEnglish.form = this.viewedForm
                    instanceEnglish.category = this.viewedForm.get('category')
                    instanceEnglish.department = this.viewedForm.get('department')
                    instanceEnglish.submission_language = this.currentSubmittingLanguage
                    instanceEnglish.createdBy = theUser

                    this.viewedFormFields.forEach((field, index) => {
                        if (field.type !== 'heading' && field.type !== 'description') {
                            let propName = field.fieldDatabaseName
                            if (field.type == 'text') {
                                if (field.fieldType == "number") {
                                    instanceEnglish[propName] = parseFloat(this.theVarsEnglish[field.fieldDatabaseName])
                                } else {
                                    instanceEnglish[propName] = this.theVarsEnglish[field.fieldDatabaseName]
                                }

                            } else if (field.type == 'date') {
                                if (this.theVarsEnglish[field.fieldDatabaseName]) {
                                    if (field.isTime) {
                                        var times = this.theVarsEnglish[field.fieldDatabaseName].split(':')
                                        var hourToSeconds = parseInt(times[0]) * 60 * 60;
                                        var minToSeconds = parseInt(times[1]) * 60;
                                        var seconds = parseInt(times[2]);
                                        var totalSeconds = hourToSeconds + minToSeconds + seconds;
                                        instanceEnglish[propName] = totalSeconds
                                    } else {
                                        if (field.isHijri) {
                                            var m = moment(this.theVarsEnglish[field.fieldDatabaseName], 'jYYYY/jMM/jDD');
                                            var miladi = moment.from(this.theVarsEnglish[field.fieldDatabaseName], 'fa', 'YYYY/MM/DD').format('YYYY/MM/DD');
                                            if (miladi) instanceEnglish[propName] = new Date(miladi)

                                        } else {
                                            instanceEnglish[propName] = new Date(this.theVarsEnglish[field.fieldDatabaseName])

                                        }
                                    }
                                } else {
                                    instanceEnglish[propName] = null
                                }

                            } else if (field.type == 'single-geolocation') {
                                instanceEnglish['latitude'] = this.theVarsEnglish['latitude']
                                instanceEnglish['longitude'] = this.theVarsEnglish['longitude']

                            } else if (field.type == 'attachment') {
                                if (field.multiple)
                                    instanceEnglish[field.fieldDatabaseName] = [];
                                else instanceEnglish[field.fieldDatabaseName] = '';
                                for (let index = 0; index < attatchmentsIds.length; index++) {
                                    if (attatchmentsIds[index].field.multiple) {
                                        if (attatchmentsIds[index].field.fieldDatabaseName == field.fieldDatabaseName) instanceEnglish[field.fieldDatabaseName].push(attatchmentsIds[index].url)
                                    } else {

                                        if (attatchmentsIds[index].field.fieldDatabaseName == field.fieldDatabaseName) instanceEnglish[field.fieldDatabaseName] = attatchmentsIds[index].url
                                    }
                                }
                            } else {
                                instanceEnglish[propName] = this.theVarsEnglish[field.fieldDatabaseName]
                            }
                        }
                    });

                    if (this.viewedForm.get('class_name')) {
                        var ClassNameEnglish = Parse.Object.extend(this.viewedForm.get('class_name'));
                        var classInstanceEnglish = new ClassNameEnglish();
                        classInstanceEnglish.save(instanceEnglish)
                            .then(async inserted => {
                                if (this.$route.matched[0].name == 'surveys') {
                                    var activityUrl;
                                    activityUrl = '/surveys/' + this.$route.params.scope + '/' + this.$route.params.category + '/' + this.$route.params.form_slug
                                    if (this.viewedForm.get('survey_submission_approvers')) {
                                        this.viewedForm.get('survey_submission_approvers').forEach(async approver => {
                                            await this.newActivity({
                                                label_english: this.viewedForm.get('label_english'),
                                                label_pashto: this.viewedForm.get('label_pashto'),
                                                label_dari: this.viewedForm.get('label_dari'),
                                                type: 'survey',
                                                action: 'newSubmission',
                                                url: activityUrl + '/list',
                                                to: approver,
                                                class: this.viewedForm.get('class_name')
                                            })
                                        })
                                    }
                                    await this.newActivity({
                                        label_english: this.viewedForm.get('label_english'),
                                        label_pashto: this.viewedForm.get('label_pashto'),
                                        label_dari: this.viewedForm.get('label_dari'),
                                        type: 'survey',
                                        action: 'newSubmission',
                                        url: activityUrl + '/list/' + inserted.id,
                                        to: null,
                                        class: this.viewedForm.get('class_name')
                                    })
                                    if (!this.$route.meta.isPublicView) this.$router.go(-1)
                                    this.$notify({
                                        group: 'foo',
                                        text: this._('Your response was submitted'),
                                        duration: -4000,
                                        position: 'top left',
                                        type: 'success'
                                    });
                                }
                                resolve(inserted.id)
                                this.$store.commit('setLoading', false)

                            }).catch(e => {
                                reject('An error was encountered during submitting your response')
                                this.$store.commit('setLoading', false)
                                this.$notify({
                                    group: 'foo',
                                    title: this._('Error'),
                                    text: this._('An error was encountered during submitting your response'),
                                    duration: -4000,
                                    position: 'top left',
                                    type: 'error'
                                });
                            })
                    } else {
                        this.$notify({
                            group: 'foo',
                            title: this._('System Error'),
                            text: this._('An error was encountered during submitting your response, please report the error'),
                            duration: -4000,
                            position: 'top left',
                            type: 'error'
                        });
                    }
                })
            },

            async  newActivity(payload) {
                let Activity = new Parse.Object.extend("Activity");
                let newActivity = new Activity();
                let activity = {
                    label_english: payload.label_english,
                    label_pashto: payload.label_pashto,
                    label_dari: payload.label_dari,
                    type: payload.type,
                    action: payload.action,
                    createdBy: this.user,
                    url: payload.url,
                    to: payload.to,
                    department: this.viewedForm.get('department'),
                    category: this.viewedForm.get('category'),
                    reference_id: this.viewedForm.id,
                    seen: false,
                    previous_label_english: payload.previous_label_english,
                    previous_label_pashto: payload.previous_label_pashto,
                    previous_label_dari: payload.previous_label_dari,
                    class: payload.class,
                };

                await newActivity
                    .save(activity)
                    .then(inserted => { })

                    .catch(e => { });
            },

            showErrorNotification(message) {
                this.$notify({
                    group: 'foo',
                    text: message,
                    duration: 4000,
                    position: 'top left',
                    type: 'error'
                });
            },

            validateForm(localTheVars, lang) {
                for (let index = 0; index < this.viewedFormFields.length; index++) {

                    let field = this.viewedFormFields[index]

                    if (field.type != 'heading' && field.type != 'description') {
                        if (field.required) {
                            if (field.type == 'multiple-option' || field.type == 'multiple-geolocation') {
                                if (localTheVars[field.fieldDatabaseName].length == 0) {
                                    this.errorContent = { messageEnglish: field.type == 'multiple-option' ? 'Please select an option' : 'Please add geo-points', messagePashto: field.type == 'multiple-option' ? 'مهرباني وکړئ یو انتخاب غوره کړئ' : 'مهرباني وکړئ یو جیو پوینټ اضافه کړئ', messageDari: field.type == 'multiple-option' ? 'لطفا یک گزینه را انتخاب کنید' : 'لطفاً یک نقطه جغرافیایی اضافه کنید', fieldDatabaseName: field.fieldDatabaseName }
                                    this.$store.commit('setLoading', false)
                                    this.showErrorNotification(this.errorContent['message' + this.currentSubmittingLanguage.charAt(0).toUpperCase() + this.currentSubmittingLanguage.slice(1)])
                                    return false
                                } else this.errorContent = { messageEnglish: '', messagePashto: '', messageDari: '', fieldDatabaseName: field.fieldDatabaseName }
                            } if (field.type == 'single-option') {
                                if (!localTheVars[field.fieldDatabaseName]) {
                                    this.errorContent = { messageEnglish: 'Please select an option', messagePashto: 'مهرباني وکړئ یو انتخاب غوره کړئ', messageDari: 'لطفا یک گزینه را انتخاب کنید', fieldDatabaseName: field.fieldDatabaseName }
                                    this.$store.commit('setLoading', false)
                                    this.showErrorNotification(this.errorContent['message' + this.currentSubmittingLanguage.charAt(0).toUpperCase() + this.currentSubmittingLanguage.slice(1)])
                                    return false
                                } else this.errorContent = { messageEnglish: '', messagePashto: '', messageDari: '', fieldDatabaseName: field.fieldDatabaseName }
                            } else if (field.type == 'checkbox') {

                            } else if (field.type == 'date') {
                                if (localTheVars[field.fieldDatabaseName] == '' || localTheVars[field.fieldDatabaseName] == null || localTheVars[field.fieldDatabaseName] == undefined) {
                                    this.errorContent = { messageEnglish: 'Please choose the date/time', messagePashto: 'مهرباني وکړئ نیټه/وخت وټاکئ', messageDari: 'لطفا تاریخ/زمان را انتخاب کنید', fieldDatabaseName: field.fieldDatabaseName }
                                    this.$store.commit('setLoading', false)
                                    this.showErrorNotification(this.errorContent['message' + this.currentSubmittingLanguage.charAt(0).toUpperCase() + this.currentSubmittingLanguage.slice(1)])
                                    return false
                                } else this.errorContent = { messageEnglish: '', messagePashto: '', messageDari: '', fieldDatabaseName: field.fieldDatabaseName }

                            } else if (field.type == 'single-geolocation') {
                                if (localTheVars['latitude'] == 0 && localTheVars['longitude'] == 0) {
                                    this.errorContent = { messageEnglish: 'Please add one geo-point', messagePashto: 'مهرباني وکړئ یو جیو پوینټ اضافه کړئ', messageDari: 'لطفاً یک نقطه جغرافیایی اضافه کنید', fieldDatabaseName: field.fieldDatabaseName }
                                    this.$store.commit('setLoading', false)
                                    this.showErrorNotification(this.errorContent['message' + this.currentSubmittingLanguage.charAt(0).toUpperCase() + this.currentSubmittingLanguage.slice(1)])
                                    return false
                                } else this.errorContent = { messageEnglish: '', messagePashto: '', messageDari: '', fieldDatabaseName: field.fieldDatabaseName }

                            } else if (field.type == 'attachment' || field.type == 'select') {

                                if (field.multiple) {
                                    if (localTheVars[field.fieldDatabaseName].length == 0) {
                                        this.errorContent = { messageEnglish: field.type == 'attachment' ? 'Please select attachments' : 'Please select an option', messagePashto: field.type == 'attachment' ? 'مهرباني وکړئ ضمیمه کړئ' : 'مهرباني وکړئ یو انتخاب غوره کړئ', messageDari: field.type == 'attachment' ? 'لطفا ضمیمه ها را انتخاب کنید' : 'لطفا یک گزینه را انتخاب کنید', fieldDatabaseName: field.fieldDatabaseName }
                                        this.$store.commit('setLoading', false)
                                        this.showErrorNotification(this.errorContent['message' + this.currentSubmittingLanguage.charAt(0).toUpperCase() + this.currentSubmittingLanguage.slice(1)])
                                        return false
                                    } else this.errorContent = { messageEnglish: '', messagePashto: '', messageDari: '', fieldDatabaseName: field.fieldDatabaseName }
                                }
                                if (!field.multiple) {
                                    if ((field.type == 'attachment' && localTheVars[field.fieldDatabaseName].file == null) || (field.type == 'select' && !localTheVars[field.fieldDatabaseName])) {
                                        this.errorContent = { messageEnglish: field.type == 'attachment' ? 'Please select attachment' : 'Please select an option', messagePashto: field.type == 'attachment' ? 'مهرباني وکړئ ضمیمه کړئ' : 'مهرباني وکړئ یو انتخاب غوره کړئ', messageDari: field.type == 'attachment' ? 'لطفا ضمیمه ها را انتخاب کنید' : 'لطفا یک گزینه را انتخاب کنید', fieldDatabaseName: field.fieldDatabaseName }
                                        this.$store.commit('setLoading', false)
                                        this.showErrorNotification(this.errorContent['message' + this.currentSubmittingLanguage.charAt(0).toUpperCase() + this.currentSubmittingLanguage.slice(1)])
                                        return false
                                    } else this.errorContent = { messageEnglish: '', messagePashto: '', messageDari: '', fieldDatabaseName: field.fieldDatabaseName }
                                }
                            } else if (field.type == 'text' && field.fieldType == 'number') {

                                if (isNaN(parseFloat(localTheVars[field.fieldDatabaseName])) || typeof parseFloat(localTheVars[field.fieldDatabaseName]) != 'number') {
                                    this.errorContent = { messageEnglish: 'Please type a number', messagePashto: 'مهرباني وکړئ یو شمیره ولیکئ', messageDari: 'لطفاً یک عدد تایپ کنید', fieldDatabaseName: field.fieldDatabaseName }
                                    this.$store.commit('setLoading', false)
                                    this.showErrorNotification(this.errorContent['message' + this.currentSubmittingLanguage.charAt(0).toUpperCase() + this.currentSubmittingLanguage.slice(1)])
                                    return false
                                } else this.errorContent = { messageEnglish: '', messagePashto: '', messageDari: '', fieldDatabaseName: field.fieldDatabaseName }

                            } else {
                                if (localTheVars[field.fieldDatabaseName] == '' || localTheVars[field.fieldDatabaseName] == null || localTheVars[field.fieldDatabaseName] == undefined) {
                                    this.errorContent = { messageEnglish: 'This field is required', messagePashto: 'اړتیا ده', messageDari: 'ضرورت است', fieldDatabaseName: field.fieldDatabaseName }
                                    this.$store.commit('setLoading', false)
                                    this.showErrorNotification(this.errorContent['message' + this.currentSubmittingLanguage.charAt(0).toUpperCase() + this.currentSubmittingLanguage.slice(1)])
                                    return false
                                } else this.errorContent = { messageEnglish: '', messagePashto: '', messageDari: '', fieldDatabaseName: field.fieldDatabaseName }
                            }
                        }
                    }
                }
                return true;
            },

            async submitNewEntry() {
                if (this.is_preview) return false;
                return new Promise(async (resolve, reject) => {
                    if (!this.validateForm(this.theVarsEnglish, this.currentSubmittingLanguage)) {
                        return false;
                    }
                    var result;
                    if (this.$route.matched[0].name == 'surveys') {
                        if (this.viewedForm && this.viewedForm.get('status') == 'running') {
                            if (this.$route.meta.isPublicView || (this.user && (this.user.get('roles').includes('admin') || this.user.get('roles').includes('manager') || (this.userIsSubmitter && (this.user.get('roles').includes('survey-editor') || this.user.get('roles').includes('submitter')))))) {
                                result = await this.submitData()
                            } else {
                                this.$notify({
                                    group: 'foo',
                                    text: this._('Permission deenied'),
                                    duration: -4000,
                                    position: 'top left',
                                    type: 'error'
                                });
                            }
                        } else {
                            var message = '';
                            if (this.viewedForm.get('status') == 'completed') {
                                message = 'Survey is completed, can not accept any submission'
                            } else if (this.viewedForm.get('status') == 'paused') {
                                message = 'Survey is paused'
                            } else if (this.viewedForm.get('status') == 'pending') {
                                message = 'Survey is not launched yet'
                            }
                            this.$notify({
                                group: 'foo',
                                text: this._(message),
                                duration: 4000,
                                position: 'top left',
                                type: 'warn'
                            });
                        }
                    } else {
                        if (this.viewedForm && this.viewedForm.get('status') == 'running') {
                            result = await this.submitData()
                        } else {
                            this.$notify({
                                group: 'foo',
                                title: this._('System Error'),
                                text: this._('Meta data can not be saved, please report the error'),
                                duration: 4000,
                                position: 'top left',
                                type: 'warn'
                            });
                        }
                    }

                    // this resovle is for other sections, not for submissions
                    resolve({ metaFormEntryId: result, metaFormLayout: this.viewedForm, submission_language: this.currentSubmittingLanguage })
                })
            },

            async updateSubmission() {
                if (this.is_preview) return false;
                if (this.viewedForm && this.viewedSubmission && this.user && !this.$route.meta.isPublicView) {
                    return new Promise(async (resolve, reject) => {
                        if (!this.validateForm(this.theVarsEnglish, this.currentSubmittingLanguage)) {
                            return false;
                        }

                        this.$store.commit('setLoading', true)
                        if (this.viewedForm.get('layout')) {
                            for (let i = 0; i < this.viewedForm.get('layout').length; i++) {
                                const field = this.viewedForm.get('layout')[i];
                                if (field.type == 'attachment') {
                                    await Promise.all(this.uploadAttachments(field))
                                        .then(async attachmentsUrls => {

                                            if (field.multiple) {
                                                var oldAttachments = [];
                                                oldAttachments = this.theVarsEnglish[field.fieldDatabaseName].filter(a => !a.isNew)
                                                if (attachmentsUrls && attachmentsUrls.length != 0) {
                                                    attachmentsUrls.forEach(attachment => {
                                                        if (field.fieldDatabaseName == attachment.field.fieldDatabaseName) {
                                                            oldAttachments.push({
                                                                file: { name: attachment.url.split('/')[attachment.url.split('/').length - 1] },
                                                                url: attachment.url,
                                                                isNew: false
                                                            })
                                                        }
                                                    })
                                                }
                                                this.theVarsEnglish[field.fieldDatabaseName] = oldAttachments
                                            } else {
                                                if (attachmentsUrls && attachmentsUrls.length != 0) {
                                                    attachmentsUrls.forEach(attachment => {
                                                        if (field.fieldDatabaseName == attachment.field.fieldDatabaseName) {
                                                            this.theVarsEnglish[field.fieldDatabaseName] = {
                                                                file: { name: attachment.url.split('/')[attachment.url.split('/').length - 1] },
                                                                url: attachment.url,
                                                                isNew: false
                                                            }
                                                        }
                                                    })
                                                }
                                            }
                                            this.theVarsEnglish = { ...this.theVarsEnglish }
                                        }).catch(e => {
                                            reject('An error accured while upload attachments')
                                            this.$notify({
                                                group: 'foo',
                                                title: this._('Error'),
                                                text: this._('An error accured while upload attachments'),
                                                duration: -4000,
                                                position: 'top left',
                                                type: 'error'
                                            });
                                        })
                                }

                            }

                            this.viewedForm.get('layout').forEach((field, index) => {
                                if (field.editable) {
                                    if (field.type != 'heading' && field.type != 'description') {
                                        let propName = field.fieldDatabaseName
                                        if (field.type == 'text') {
                                            if (field.fieldType == 'number') {
                                                this.viewedSubmission.set(propName, parseFloat(this.theVarsEnglish[field.fieldDatabaseName]))
                                            } else {
                                                this.viewedSubmission.set(propName, this.theVarsEnglish[field.fieldDatabaseName])
                                            }
                                        } else if (field.type == 'date') {


                                            if (this.theVarsEnglish[field.fieldDatabaseName]) {
                                                if (field.isTime) {
                                                    var times = this.theVarsEnglish[field.fieldDatabaseName].split(':')
                                                    var hourToSeconds = parseInt(times[0]) * 60 * 60;
                                                    var minToSeconds = parseInt(times[1]) * 60;
                                                    var seconds = parseInt(times[2]);
                                                    var totalSeconds = hourToSeconds + minToSeconds + seconds;
                                                    this.viewedSubmission.set(propName, totalSeconds)
                                                } else {
                                                    if (field.isHijri) {
                                                        var m = moment(this.theVarsEnglish[field.fieldDatabaseName], 'jYYYY/jMM/jDD');
                                                        var miladi = moment.from(this.theVarsEnglish[field.fieldDatabaseName], 'fa', 'YYYY/MM/DD').format('YYYY/MM/DD');
                                                        if (miladi) this.viewedSubmission.set(propName, new Date(miladi))

                                                    } else {
                                                        this.viewedSubmission.set(propName, new Date(this.theVarsEnglish[propName]))

                                                    }
                                                }
                                            } else {
                                                this.viewedSubmission.set(propName, null)
                                            }

                                            // if (this.theVarsEnglish[field.fieldDatabaseName]) {
                                            //     this.viewedSubmission.set(propName, new Date(this.theVarsEnglish[propName]))
                                            // } else {
                                            //     this.viewedSubmission.set(propName, null)
                                            // }

                                        } else if (field.type == 'attachment') {
                                            var temp = [];
                                            if (field.multiple) {
                                                if (this.theVarsEnglish[propName]) {
                                                    temp = this.theVarsEnglish[propName].map(att => att.url)
                                                    this.viewedSubmission.set(propName, temp)
                                                }
                                            } else {
                                                if (this.theVarsEnglish[propName]) {
                                                    this.viewedSubmission.set(propName, this.theVarsEnglish[propName]['url'])
                                                }
                                            }
                                        } else if (field.type == 'single-geolocation') {
                                            this.viewedSubmission.set('latitude', this.theVarsEnglish['latitude'])
                                            this.viewedSubmission.set('longitude', this.theVarsEnglish['longitude'])
                                        } else {
                                            this.viewedSubmission.set(propName, this.theVarsEnglish[field.fieldDatabaseName])
                                        }
                                    }
                                }
                            });


                            // updating
                            await this.viewedSubmission.save().then(async updated => {
                                this.viewedSubmission = updated
                                if (this.$route.matched[0].name == 'surveys') {
                                    var activityUrl;
                                    activityUrl = '/surveys/' + this.$route.params.scope + '/' + this.$route.params.category + '/' + this.$route.params.form_slug
                                    if (this.viewedForm.get('survey_submission_approvers')) {
                                        this.viewedForm.get('survey_submission_approvers').forEach(async approver => {
                                            await this.newActivity({
                                                label_english: this.viewedForm.get('label_english'),
                                                label_pashto: this.viewedForm.get('label_pashto'),
                                                label_dari: this.viewedForm.get('label_dari'),
                                                type: 'survey',
                                                action: 'updateSubmission',
                                                url: activityUrl + '/list/' + updated.id,
                                                to: approver,
                                                category: this.viewedForm.get('category'),
                                                department: this.viewedForm.get('department'),
                                                class: this.viewedForm.get('class_name')
                                            })
                                        })
                                    }
                                    await this.newActivity({
                                        label_english: this.viewedForm.get('label_english'),
                                        label_pashto: this.viewedForm.get('label_pashto'),
                                        label_dari: this.viewedForm.get('label_dari'),
                                        type: 'survey',
                                        action: 'updateSubmission',
                                        url: activityUrl + '/list/' + updated.id,
                                        to: null,
                                        category: this.viewedForm.get('category'),
                                        department: this.viewedForm.get('department'),
                                        class: this.viewedForm.get('class_name')
                                    })
                                    this.$notify({
                                        group: 'foo',
                                        text: this._('Submission was update'),
                                        duration: -4000,
                                        position: 'top left',
                                        type: 'success'
                                    });
                                    this.$router.go(-1)

                                } else {

                                }
                                resolve(updated)
                                this.$store.commit('setLoading', false)

                            }).catch(error => {
                                reject('An error accured while updating submission')
                                this.$store.commit('setLoading', false)
                                var message = '';
                                if (this.viewedForm.get('class_name').slice(5) != this.$route.params.form_slug) {
                                    message = 'This link is expired'
                                } else {
                                    message = 'An error was encountered during submitting your response'
                                }
                                this.$notify({
                                    group: 'foo',
                                    title: this._('Error'),
                                    text: this._(message),
                                    duration: -4000,
                                    position: 'top left',
                                    type: 'error'
                                });
                            })
                        }
                    })
                }
            },

            fetchedSubmissionDataBinding() {
                if (this.myForm && this.viewedSubmission) {
                    for (let i = 0; i < this.myForm.get('layout').length; i++) {
                        const field = this.myForm.get('layout')[i];
                        if (field.type != 'heading' && field.type != 'description' && field.type != 'sub-form') {
                            if (field.type == 'single-geolocation') {
                                this.theVarsEnglish['latitude'] = this.viewedSubmission.get('latitude')
                                this.theVarsEnglish['longitude'] = this.viewedSubmission.get('longitude')
                            } else if (field.type == 'attachment') {
                                if (field.multiple) {
                                    if (this.viewedSubmission.get(field.fieldDatabaseName) && this.viewedSubmission.get(field.fieldDatabaseName).length != 0) {
                                        this.theVarsEnglish[field.fieldDatabaseName] = this.viewedSubmission.get(field.fieldDatabaseName).map(att => {
                                            if (att) {
                                                return {
                                                    file: { name: att.split('/')[att.split('/').length - 1] },
                                                    url: att,
                                                    isNew: false
                                                }
                                            }
                                        })
                                    }
                                } else if (!field.multiple) {
                                    if (this.viewedSubmission.get(field.fieldDatabaseName)) {
                                        this.theVarsEnglish[field.fieldDatabaseName] = {
                                            file: { name: this.viewedSubmission.get(field.fieldDatabaseName).split('/')[this.viewedSubmission.get(field.fieldDatabaseName).split('/').length - 1] },
                                            url: this.viewedSubmission.get(field.fieldDatabaseName),
                                            isNew: false
                                        }
                                    }
                                }
                            } else if (field.type == 'date') {
                                if (this.viewedSubmission && this.viewedSubmission.get(field.fieldDatabaseName)) {
                                    if (field.isTime) {
                                        this.theVarsEnglish[field.fieldDatabaseName] = moment.utc(this.viewedSubmission.get(field.fieldDatabaseName) * 1000).format('HH:mm:ss')
                                    } else {
                                        if (field.isHijri) {
                                            var date = new Date(this.viewedSubmission.get(field.fieldDatabaseName))
                                            var stringDate = date.getFullYear() + '/' + parseInt(1 + date.getMonth()) + '/' + date.getDate()
                                            var hijriDate = moment(stringDate, 'YYYY/MM/DD').locale('fa').format('YYYY/MM/DD');
                                            this.theVarsEnglish[field.fieldDatabaseName] = hijriDate
                                        } else {
                                            var date = new Date(this.viewedSubmission.get(field.fieldDatabaseName))
                                            this.theVarsEnglish[field.fieldDatabaseName] = date.getFullYear() + '/' + parseInt(1 + date.getMonth()) + '/' + date.getDate()
                                        }
                                    }
                                }
                            } else {
                                this.theVarsEnglish[field.fieldDatabaseName] = this.viewedSubmission.get(field.fieldDatabaseName)
                            }
                        }
                    }
                    this.theVarsEnglish = { ...this.theVarsEnglish }
                }
            },

            varBinder() {
                if (this.myForm && this.myForm.get('layout')) {
                    this.myForm.get('layout').forEach(field => {
                        if (field.type !== 'heading' && field.type !== 'description') {
                            if (field.type == 'text') {
                                if (field.fieldType == 'number') {
                                    this.theVarsEnglish[field.fieldDatabaseName] = 0
                                } else {
                                    this.theVarsEnglish[field.fieldDatabaseName] = ''
                                }
                            } else if (field.type == 'textarea' || field.type == 'single-option' || field.type == 'date') {
                                this.theVarsEnglish[field.fieldDatabaseName] = ''
                            } else if (field.type == 'checkbox') {
                                this.theVarsEnglish[field.fieldDatabaseName] = false
                            } else if (field.type == 'select' || field.type == 'attachment') {
                                if (field.multiple) {
                                    this.theVarsEnglish[field.fieldDatabaseName] = []
                                } else {
                                    this.theVarsEnglish[field.fieldDatabaseName] = ''
                                }
                            } else if (field.type == 'multiple-option' || field.type == 'multiple-geolocation') {
                                this.theVarsEnglish[field.fieldDatabaseName] = []

                            } else if (field.type == 'single-geolocation') {
                                this.theVarsEnglish['latitude'] = 0;
                                this.theVarsEnglish['longitude'] = 0;
                            }
                        }
                    })
                }
            },

            async fetchSubmission() {
                if (this.$route.matched[0].name == 'surveys') {
                    if (this.myForm && this.myForm.get('status') != 'pending' && this.myForm.get('class_name')) {
                        var q = new Parse.Query(this.myForm.get('class_name'))
                        this.viewedSubmission = await q.get(this.$route.params.id)
                        if (this.viewedSubmission) {
                            this.currentSubmittingLanguage = this.viewedSubmission.get('submission_language')
                        }
                    }
                }
            },

            async fetchings() {
                this.$store.commit('setLoading', true)
                if (this.is_preview) {
                    if (this.$route.params.id) {
                        var q = new Parse.Query("Form")
                        q.equalTo('objectId', this.$route.params.id)
                        q.include('createdBy')
                        q.include('department')
                        q.include('category')
                        this.viewedForm = await q.first()
                        this.myForm = this.viewedForm
                        this.viewedFormFields = this.viewedForm.get('layout')
                        this.formLanguages = this.viewedForm.get('form_languages')
                        this.currentSubmittingLanguage = this.formLanguages[0]
                        this.varBinder()
                    }
                } else {
                    if (this.$route.matched[0].name == 'surveys') {
                        let q = new Parse.Query('Form')
                        q.equalTo('is_enabled', true)
                        q.equalTo('class_name', 'Data_' + this.$route.params.form_slug)
                        var formRes = await q.first()
                        this.viewedForm = formRes
                        this.myForm = formRes
                        if (!this.$route.meta.isPublicView) {
                            if (this.viewedForm.get('survey_submitters')) this.viewedForm.get('survey_submitters').forEach(user => {
                                if (user.id == this.user.id) this.isThisUserSubmitter = true
                            })
                        }
                        this.viewedFormFields = this.viewedForm.get('layout')
                        this.formLanguages = this.viewedForm.get('form_languages')
                        this.currentSubmittingLanguage = this.formLanguages[0]
                        this.varBinder()
                    }
                }
                this.$store.commit('setLoading', false)
            }
        },

        async mounted() {
            await this.fetchings()
            // check if it is editing existing submission (fetch submission and its subform entries) or creating new submission
            if (this.$route.params.id != 'new' && !this.is_preview) {
                await this.fetchSubmission()
            }
            if (this.$route.matched[0].name == 'surveys' && !this.is_preview) this.fetchedSubmissionDataBinding()
        }
    };
</script>

<style>
    .submissionSection {
        display: flex;
    }

    .otherSections {
        display: flex;
        flex-direction: row;
    }

    .file_chip {
        margin: 5px 0;
        /* background: #333; */
        border: 1px solid gray;
        border-radius: 3px;
        height: 28px;
        max-width: 150px;
        display: flex;
        padding: 0px 4px;
    }

    .file-text {
        font-size: 0.8em;
        height: 17px;
        margin-top: 4px;
        max-width: 150px;
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        flex: 1 !important
    }

    .uploader-example {
        /* width: 550px; */
        padding: 15px;
        margin: 10px 0;
        font-size: 12px;
        box-shadow: 0 0 10px rgba(0, 0, 0, .4);
    }

    .uploader-example .uploader-btn {
        margin-right: 4px;
    }

    .uploader-example .uploader-list {
        max-height: 440px;
        overflow: auto;
        overflow-x: hidden;
        overflow-y: auto;
    }

    .field_item .va-flex {
        display: block !important;
        width: 100% !important
    }

    .field_item .va-dropdown-con,
    .field_item .va-radio-group,
    .field_item .va-input-con,
    .field_item .va-textarea-con,
    .field_item .va-select-btn,
    .field_item .va-select-group,
    .field_item .va-select-items-wrapper,
    .field_item .va-dropdown-menu {
        width: 100% !important;
    }

    .full_with_input {
        width: 100% !important;
    }


    .field_item .va-input-con .va-form-control {
        width: 100% !important;
    }

    .field_item .va-textarea-con .va-form-control {
        width: 100% !important;
    }


    .form_rtl {
        direction: rtl !important
    }

    .form_ltr {
        direction: ltr !important
    }


    .not_available {
        z-index: 2147483647;
        height: 40px;
        width: 50%;
        margin: auto;
        position: absolute;
        top: 50%;
        margin-top: -20px;
        left: 0;
        right: 0;
        text-align: center;
        color: red;
        font-size: 20px;
        text-transform: uppercase
    }

    .fixed_direction {
        direction: ltr
    }

    .lat_rtl {
        margin-bottom: 5px !important
    }

    .lat_ltr {
        margin-right: 10px !important;
        margin-bottom: 5px !important
    }

    .long_rtl {
        margin-bottom: 5px !important
    }

    .long_ltr {
        margin-right: 10px !important;
        margin-bottom: 5px !important
    }

    /* @-webkit-keyframes blackWhite {
        0% {
            background-color: #563c3c;
        }

        50% {
            background-color: #563c3c;
        }

        51% {
            background-color: initial;
        }

        100% {
            background-color: initial;
        }
    }

    .error_indicator {
        background: #563c3c;
        -webkit-animation-name: blackWhite;
        -webkit-animation-duration: 2s;
    } */

    .vpd-input-group input {
        width: 100% !important;
    }
</style>